import React from "react";
import { useTranslation } from "react-i18next";
import Fade from 'react-reveal/Fade';

const items = [
  { titleKey: "support.why.1.title", textKey: "support.why.1.text" },
  { titleKey: "support.why.2.title", textKey: "support.why.2.text" },
  { titleKey: "support.why.3.title", textKey: "support.why.3.text" },
  { titleKey: "support.why.4.title", textKey: "support.why.4.text" },
  { titleKey: "support.why.5.title", textKey: "support.why.5.text" },
  { titleKey: "support.why.6.title", textKey: "support.why.6.text" },
];

const BORDER = "border-[rgba(19,50,97,0.3)]";

function WhyChoose() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block mx-auto max-w-[1220px]">
        {/* Title */}
        <Fade bottom>
        <div className="flex flex-col items-center gap-[20px] text-center">
          <p className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
            {t("support.why.title1")}
          </p>
          <p className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#3273b4]">
            {t("support.why.title2")}
          </p>
          <span className={`block h-[4px] w-[104px] bg-[#05193a]`} />
        </div>

        </Fade>

        {/* Grid */}
        <Fade bottom delay={200}>
        <div className={`mt-[40px] border ${BORDER}`}>
          {/* Row 1 */}
          <div className="grid grid-cols-3">
            {items.slice(0, 3).map((item, i) => (
              <div
                key={i}
                className={`h-[126px] px-[26px] flex flex-col justify-center gap-[8px] ${i < 2 ? `border-r ${BORDER}` : ""}`}
              >
                <p className="font-['Nunito_Sans'] text-[32px] font-normal leading-[1.5] text-[#05193a]">
                  {t(item.titleKey)}
                </p>
                <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
                  {t(item.textKey)}
                </p>
              </div>
            ))}
          </div>

          {/* Row 2 */}
          <div className={`grid grid-cols-3 border-t ${BORDER}`}>
            {items.slice(3, 6).map((item, i) => (
              <div
                key={i}
                className={`h-[126px] px-[26px] flex flex-col justify-center gap-[8px] ${i < 2 ? `border-r ${BORDER}` : ""}`}
              >
                <p className="font-['Nunito_Sans'] text-[32px] font-normal leading-[1.5] text-[#05193a]">
                  {t(item.titleKey)}
                </p>
                <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.4] text-[#05193a]">
                  {t(item.textKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
        </Fade>
      </div>

      {/* Mobile */}
      <Fade bottom>
      <div className="xl:hidden px-[20px]">
        <div className="flex flex-col items-center gap-[12px] text-center">
          <p className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t("support.why.title1")}
          </p>
          <p className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
            {t("support.why.title2")}
          </p>
          <span className="block h-[4px] w-[104px] bg-[#05193a]" />
        </div>

        <div className={`mt-[30px] border ${BORDER}`}>
          {items.map((item, i) => (
            <div
              key={i}
              className={`px-[26px] py-[24px] ${
                i < items.length - 1 ? `border-b ${BORDER}` : ""
              }`}
            >
              <p className="font-['Nunito_Sans'] text-[26px] font-normal leading-[1.5] text-[#05193a]">
                {t(item.titleKey)}
              </p>
              <p className="mt-[8px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.4] text-[#05193a]">
                {t(item.textKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default WhyChoose;
